import { useState } from 'react';

import cs from 'classnames';
import { appointment_lengths } from 'constants';

import { useNewAppointmentContext } from 'lib/context/Appointment/NewAppointmentContext';
import { ia, io } from 'lib/helpers/utility';

import DatePicker from 'components/shared/DatePicker/DatePicker';
import Select from 'components/shared/Select/Select';
import Switch from 'components/shared/Switch/Switch';
import TimePicker from 'components/shared/TimePicker/TimePicker';

import { handleRepeatEvent } from '../../EventForm/lib';

import AppointmentRecurrence from './AppointmentRecurrence/AppointmentRecurrence';
import TimeSlots from './TimeSlots';

const AppointmentDateAndTime = ({
  practice,
  dateAndTime,
  handleLoadMore,
  selectAppointmentLocation,
  selectedTimeLength,
  selectTimeLength
}) => {
  const [showRecurrence, setShowRecurrence] = useState(false);
  const { formik } = useNewAppointmentContext();
  const { setFieldValue } = formik;
  const toggleRecurrence = () => {
    if (showRecurrence) {
      [
        'repeat_event',
        'repeat_every',
        'weekdays',
        'repeat_on',
        'start_date',
        'ends_type',
        'end_date',
        'events'
      ].forEach((key) => setFieldValue(key, null));
    } else {
      handleRepeatEvent(
        setFieldValue,
        {
          label: 'Daily',
          value: '3',
          name: 'Day'
        },
        formik.values.startsAt
      );
      setFieldValue('repeat_every', 1);
    }

    setShowRecurrence((prev) => !prev);
  };
  const handleChangeDateTime = (dateOrTime) => {
    const isTimeString = typeof dateOrTime === 'string' && dateOrTime.includes(':');

    const startsAt = new Date(formik.values.startsAt);

    let newDateTime;

    if (isTimeString) {
      const [hours, minutes] = dateOrTime.split(':').map(Number);
      newDateTime = new Date(startsAt);
      newDateTime.setHours(hours);
      newDateTime.setMinutes(minutes);
    } else {
      const newDate = new Date(dateOrTime);
      newDate.setHours(startsAt.getHours());
      newDate.setMinutes(startsAt.getMinutes());
      newDateTime = newDate;
    }

    formik.setFieldValue('startsAt', newDateTime);
  };

  return (
    <div>
      <div className="!mb-4">
        <div className="flex  items-start gap-2">
          <DatePicker
            value={formik.values.startsAt}
            onChange={handleChangeDateTime}
            label="Appointment date"
            iconIsRight
            isClearable={false}
            parentClassName="flex-1"
            isTimezone
            isHintWithTime
          />
          <div className="flex flex-1 flex-col">
            <label className="h-[26px] pt-1 text-sm font-500">Appointment time</label>
            <TimePicker
              value={new Date(formik.values.startsAt)}
              onChange={handleChangeDateTime}
              inputClassName="!w-full"
              className="!w-full"
            />
          </div>
          <Select
            placeholder="Appointment duration"
            inputId="select-appointment-duration"
            data-qa="appointment-duration"
            value={io(selectedTimeLength) && selectedTimeLength}
            label="Duration"
            options={appointment_lengths}
            onChange={(value) => selectTimeLength(value)}
            error={formik.touched.appointmentLength && formik.errors.appointmentLength}
            parentClassName="flex-1"
          />
        </div>

        {ia(dateAndTime.locationAvailableSlots) && (
          <TimeSlots
            day={dateAndTime}
            handleLoadMore={handleLoadMore}
            timeZone={practice?.timezone}
            type="location"
            selectAppointmentLocation={selectAppointmentLocation}
            appointmentLocation={formik.values.appointmentLocation}
          />
        )}
        {ia(dateAndTime.virtualAvailableSlots) && (
          <TimeSlots
            day={dateAndTime}
            handleLoadMore={handleLoadMore}
            timeZone={practice?.timezone}
            selectAppointmentLocation={selectAppointmentLocation}
            type="virtual"
            appointmentLocation={formik.values.appointmentLocation}
          />
        )}
      </div>

      <div className={cs('flex flex-1 items-center gap-2', showRecurrence && 'mb-3')}>
        <Switch checked={showRecurrence} onChange={toggleRecurrence} />
        <label className="text-sm font-500 ">This appointment is recurring</label>
      </div>

      {showRecurrence && <AppointmentRecurrence formik={formik} />}
    </div>
  );
};

export default AppointmentDateAndTime;
